import CoretexDialog from "//noonrise.studio/cdn/shop/t/2/assets/c-dialog.js?v=3153342825944653021743646171";

class CoretexZoomDialog extends CoretexDialog {
    constructor() {
      super();
      this.scrollToTargetImage = this.scrollToTargetImage.bind(this);
      this.closeDialogOnContentClick = this.closeDialogOnContentClick.bind(this);
      this.triggerButton = null; // Store the triggering button
    }
  
    connectedCallback() {
      super.connectedCallback();
      const zoomDialog = this.querySelector('.coretex-zoom-dialog');
      if (zoomDialog) this.dialog = zoomDialog;

      this.dialog.addEventListener('click', this.closeDialogOnContentClick);
    }
  
    disconnectedCallback() {
      super.disconnectedCallback();
      this.dialog.removeEventListener('click', this.closeDialogOnContentClick);
    }
  
    // Override openDialog to capture the triggering button
    openDialog(event) {
      const target = event.target;
      if (target.dataset.open === `#${this.id}`) { // Only act if this dialog is targeted
        this.triggerButton = target; // Store the button that triggered the open
        this.open();
      }
    }
  
    open() {
      if (!this.dialog) return;
      super.open();
      this.scrollToTargetImage();
    }
  
    scrollToTargetImage() {
      if (!this.triggerButton) return;
  
      const targetId = this.triggerButton.getAttribute('data-zoom-target');
      const targetLi = this.dialog.querySelector(`[data-zoom-target="${targetId}"]`);
  
      if (targetLi) targetLi.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  
    closeDialogOnContentClick(event) {
      this.close();
      event.stopPropagation();
    }
  }
  
if (!customElements.get('coretex-zoom-dialog')) customElements.define('coretex-zoom-dialog', CoretexZoomDialog);